import { Analytics } from '@cobliteam/analytics';
import { Button, Dialog, Typography } from '@cobliteam/ui/components';

import type { MouseEvent } from 'react';

export interface ReplaceTokenAssociationConfirmModalProps extends Omit<any, 'headerText' | 'buttonText' | 'type' | 'children'> {
  currentAssociatedDriver: string | undefined;
  token: string;
}

export const ReplaceTokenAssociationConfirmModal: React.FC<ReplaceTokenAssociationConfirmModalProps> = ({ open, loading, currentAssociatedDriver, token, onCancel, onConfirm }) => {
  const handleConfirm = () => {
    Analytics.track('Driver Replace Token Association Confirmed');
    onConfirm();
  };

  const handleCancel = (event: MouseEvent<HTMLButtonElement>) => {
    Analytics.track('Driver Replace Token Association Canceled');
    onCancel(event);
  };

  return (
    <Dialog open={open}>
      <Dialog.Portal>
        <Dialog.Content size='sm'>
          <Dialog.Header>
            <Dialog.Title>Troca de identificador</Dialog.Title>
            <Dialog.Description className='sr-only' />
            <Dialog.Close onClick={handleCancel} />
          </Dialog.Header>

          <Dialog.Body className='gap-5'>
            <Typography variant='body'>
              O identificador <b>{token}</b> está <b>associado</b> ao motorista <b>{currentAssociatedDriver}</b>
            </Typography>
            <Typography variant='body'>
              <b>Deseja desassociar o motorista do identificador e associá-lo ao novo?</b>
            </Typography>
          </Dialog.Body>

          <Dialog.Footer className='flex justify-end gap-2'>
            <Dialog.Close asChild>
              <Button variant='ghost' onClick={handleCancel}>
                Cancelar
              </Button>
            </Dialog.Close>
            <Button onClick={handleConfirm} loading={loading}>
              Confirmar
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
};
